import { Link } from "@mui/material";

export default function AmberLink(props) {
    return (
        <Link
            component="button"
            type="button"
            sx={{
                color: (theme) => theme.custom?.wizard?.amber ?? theme.palette.warning.main,
                textDecorationColor: "currentColor",
                fontWeight: 500,
            }}
            {...props}
        />
    );
}
